import { useLoginProfile } from '@/auth/useLoginProfile';
import MainLayout from '@/layouts/MainLayout';
import PageToScene from '@/scene/PageToScene';
import type { NextPage } from 'next';

const TodayFdsPage: NextPage = () => {
  const login = useLoginProfile();
  const data = login?.profile.navId === '1' ? '/clover-main' : '/clover-main';
  return (
    <MainLayout>
      <PageToScene url={data} title="대시보드" />
    </MainLayout>
  );
};

export default TodayFdsPage;
